import MenuSelectionCard from './MenuSelectionCard';

export default class MenuOrderStepsPanel extends React.Component {
    constructor(props) {
        super(props);
        this.getCardIdDataForParent = this.getCardIdDataForParent.bind(this);
        this.passPanelHeadingDataForHideOrShow = this.passPanelHeadingDataForHideOrShow.bind(this);
        this.passCardOpensModalState = this.passCardOpensModalState.bind(this);
        this.passResetModalContent = this.passResetModalContent.bind(this);
        this.passCardName = this.passCardName.bind(this);
        this.passCardOnlyPrice = this.passCardOnlyPrice.bind(this);
        this.updateRequiredStatusOnCardSelection = this.updateRequiredStatusOnCardSelection.bind(this);
        this.getRequiredText = this.getRequiredText.bind(this);
    }

    componentDidMount() { }

    componentDidUpdate() { }

    passCardOnlyPrice(cardOnlyPrice) {
        this.props.sendCardOnlyPrice(cardOnlyPrice);
    }

    updateRequiredStatusOnCardSelection() {
        const { currentSelectedItems, isRequired, id, maxselects } = this.props;

        const itemCount = currentSelectedItems.filter(item => item.categoryId == id).length;

        if (isRequired) {
            let selectCount = maxselects ? maxselects : 1;

            if (itemCount >= selectCount) {
                return (
                    <span className="default-required" data-category-id={id} data-isCompleted="true">
                        - <i className="combo-completed-text">Completed</i>
                    </span>
                );
            } else {
                return (
                    <span className="default-required" data-category-id={id} data-isCompleted="false">
                        - <i className="combo-required-text">{this.props.requiredText}</i>
                    </span>
                );
            }
        } else {
            return null;
        }
    }

    getCardIdDataForParent(idDataForParent, tiTle, price, hasMoreOption) {
        const { currentSelectedItems, sendDataForRemoval, sendIdDataToParent, id, maxselects, isRequired } = this.props;

        const itemsInSameCategory = currentSelectedItems.filter(item => item.categoryId == id);
        const itemCount = itemsInSameCategory.length;

        const isIdAlreadySelected = currentSelectedItems.some(item => item.id == idDataForParent);

        if (isIdAlreadySelected) {
            sendDataForRemoval(idDataForParent, tiTle, price);
        } else {
            let allowedCount = (maxselects == null && isRequired == true) ? 1 : maxselects;
            if (allowedCount != null && itemCount >= allowedCount) {
                const itemToRemove = itemsInSameCategory[0];
                sendDataForRemoval(itemToRemove.id, itemToRemove.title, itemToRemove.price);
            }

            sendIdDataToParent(idDataForParent, id, price);
        }
    }

    passPanelHeadingDataForHideOrShow(panelTiTle) {
        this.props.sendPanelTitleForHideAndShow(panelTiTle);
    }

    passCardOpensModalState(modalState) {
        this.props.sendCardOpensModalState(modalState);
    }

    passResetModalContent(modalResetState) {
        this.props.shouldModalContentBeCleared(modalResetState);
    }

    passCardName(cardName) {
        this.props.sendCardNameForModalReset(cardName);
    }

    getRequiredText() {
        const { isRequired } = this.props;

        if (isRequired) {
            return this.updateRequiredStatusOnCardSelection();
        } else {
            return null;
        }
    }

    render() {
        return (
            <div>
                <div className="menu-category mg-70" id="hideCategory">
                    <div className="category-header">
                        <h2 className="h1 category-title category-title-v-2 ">
                            {this.props.tiTle}
                            {this.getRequiredText()}
                        </h2>
                        <span className="category-subtitle">{this.props.description}</span>
                    </div>

                    <div className={`category-body position-relative ${this.props.id}`}>
                        <MenuSelectionCard
                            sendSelectedCardId={this.getCardIdDataForParent}
                            menuOrderCardData={this.props.menuOrderCardData}
                            updateModalData={this.props.updateModalData}
                            updateModalHeader={this.props.updateModalHeader }
                            updateRenderModalState={this.props.updateRenderModalState}
                            updateModalId={this.props.updateModalId}    
                            updateModalImage={this.props.updateModalImage} 
                            sendCardOpensModalState={this.props.sendCardOpensModalState}
                            sendModalContentResetStatus={this.props.sendModalContentResetStatus}  
                            sendCustomizedBtnStatus={this.props.sendCustomizedBtnStatus }
                            sendTitleDataTohideOrShow={this.props.tiTle}
                            currentSelectedItems={this.props.currentSelectedItems}
                            checkButtonStatusOnCardClick={this.props.checkButtonStatusOnCardClick}
                            customizeButtonText={this.props.customizeButtonText}
                            sendCardOpensModalState={this.passCardOpensModalState}
                            resetModalContent={this.passResetModalContent}
                            defaultModifierImage={this.props.defaultModifierImage}
                            sendCardName={this.passCardName}
                            sendCardOnlyPrice={this.passCardOnlyPrice}
                            caloriesText={this.props.caloriesText}
                            calorieAbbr={this.props.calorieAbbr}
                            calorieAdds={this.props.calorieAdds}
                            calorieSubtracts={this.props.calorieSubtracts}
                        />
                    </div>
                </div>
            </div>
        );
    }
}